const FastWay_conf = {
  title: '',
  itemPrefix: 'SBGStoreBackend'
};

export default FastWay_conf;
